import API from "../../../../../services/api";

export const SOLICITUD_ALTERNATIVAS_API = {
    get: async (page = 1, search = null) => {
        return await API.get(`/solicitud-alternativas?page=${page}${search || ''}`).then(res => res.data);
    },
    getPendientesCount: async () => {
        return API.get('/solicitud-alternativas/pendientes-count').then((res) => res.data);
    },
    getStates: async () => {
        return await API.get(`/solicitud-alternativas/estados`).then(res => res.data);
    },
    getVentaOrigen: async (numPresupuesto) => {
        return await API.get(`solicitud-alternativas/origen/${numPresupuesto}`).then(res => res.data);
    },
    create: async (data) => {
        return await API.post('/solicitud-alternativas/nueva', data).then(res => res.data);
    },
    asignar: async (data) => {
        return await API.put('/solicitud-alternativas/asignar', data).then(res => res.data);
    },
    getResponderData: async (id) => {
        return await API.get(`/solicitud-alternativas/${id}/responder`).then(res => res.data);
    },
    searchAlternativa: async (numPresupuesto) => {
        return await API.get(`/solicitud-alternativas/alternativa/${numPresupuesto}`).then(res => res.data);
    },
    responder: async (data) => {
        return await API.post('/solicitud-alternativas/responder', data).then(res => res.data);
    },
    sinAlternativa: async (data) => {
        return await API.post('/solicitud-alternativas/sin-alternativa', data).then(res => res.data);
    },
    getDetalleRevision: async (id) => {
        return await API.get(`/solicitud-alternativas/${id}/detalle/revision`).then(res => res.data);
    },
    getDetalleFinanzas: async (id) => {
        return await API.get(`/solicitud-alternativas/${id}/detalle/finanzas`).then(res => res.data);
    },
    getDetalleMasInformacion: async (id) => {
        return await API.get(`/solicitud-alternativas/${id}/detalle/mas-informacion`).then(res => res.data);
    },
    enviarMasInformacion: async (data) => {
        return await API.post('/solicitud-alternativas/mas-informacion', data).then(res => res.data);
    },
    ejecutarAccionAtCliente: async (data) => {
        return await API.post('/solicitud-alternativas/accion-at-cliente', data).then(res => res.data);
    },
    finalizarGestionFinanzas: async (solicitudId) => {
        return await API.post('/solicitud-alternativas/finalizar-finanzas', {
            solicitud_id: solicitudId,
        }).then(res => res.data);
    },
    remove: async (id) => {
        return await API.delete(`/solicitud-alternativas/${id}`).then(res => res.data);
    },
}
